<template>
    <div class="trial-section">
        <div class="trial-section-inner">
        <div class="section-header">
            <h2>
                テクノロジーに関する組織の
                <br class="hide-pc show-tab">
                課題解決ならお任せください
            </h2>
            <p class="hide-sp">
                エンジニア不足、デザイナー不足、組織のテクノロジー化の遅れなど
                <br>
                あなたの組織がテクノロジーに関して課題を感じているならお気軽にお問い合わせください
            </p>
            <a href="" class="action-btn btn business-btn">
                お問い合わせはこちら
            </a>
            <a href="" class="action-btn white-btn btn ">
                <span class="hide-sp">まずは</span>
                資料をダウンロード
            </a>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'Trial'
}
</script>

<style scoped>
    .trial-section .btn {
        padding: 14px 68px;
        line-height: 28px;
        font-size: 1.3rem;
        border-radius: 10px;
    }

    .white-btn {
        background-color: #fff;
        border: 1px solid #ddd;
        margin-left: 20px;
    }

    .btn {
        padding: 14px 68px;
        line-height: 28px;
        font-size: 1.3rem;
        border-radius: 10px;
        display: inline-block;
        
    }

    .business-btn {
        color: #fff;
        background-color: #007972;
    }

    a {
        color: var(--main-text-color);
        text-decoration: none;
    }

    @media screen and (max-width: 767px) {
        .trial-section-inner {
            padding: 0 20px;
        }

        .trial-section .btn {
            margin-top: 10px;
            width: 100%;
            padding: 10px 0;
            line-height: 24px;
            font-size: 1rem;
            border-radius: 6px;
        }

        .white-btn {
            margin-left: 0;
        }
    }
    
</style>